"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AsHtml;
exports.render = render;

var _react = _interopRequireDefault(require("react"));

var _Text = require("./Text");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function render({
  value,
  interpolations,
  tagType,
  props
}) {
  props = { ...props,
    dangerouslySetInnerHTML: {
      __html: (0, _Text.get)(value, interpolations)
    }
  };
  return /*#__PURE__*/_react.default.createElement(tagType, props);
}

function AsHtml({
  value,
  interpolations,
  tagType = "div",
  ...props
}) {
  return render({
    value,
    interpolations,
    tagType,
    props
  });
}